import InputText, { InputType } from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { setPayerINN } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

const PayerINN = () => {
    const dispatch = useDispatch();
    const { payerINN, payerErrors, payerType } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <ClickmeFormItem
            input={
                <InputText
                    type={InputType.Number}
                    value={payerINN}
                    onChange={(value) => dispatch(setPayerINN(value))}
                    placeholder={trl('InvoiceAndPayerForm.PayerCreate.PayerINN.placeholder')}
                    invalid={Boolean(payerErrors.inn)}
                    data-qa="inn"
                />
            }
            legend={trl('InvoiceAndPayerForm.PayerCreate.PayerINN.legend')}
            hint={trl(`InvoiceAndPayerForm.PayerCreate.PayerINN.hint.${payerType}`)}
            isRequired
            error={payerErrors.inn}
        />
    );
};

export default PayerINN;
